import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthenticationStore } from 'app/permission/services/authentication.store';
import { UserLocalStorageService } from 'app/permission/services/user.local.storage.service';
import { Page } from 'app/shared/models/page';
import { List } from 'immutable';
import { EventMatchLog } from '../models/event-match-log';
import { EventMatchLogStore } from '../service/event-match-log.store';
import { PagesizeType } from '../service/pagination/pagesize-type';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import { MultiAgency } from 'app/shared/models/multi-agency';
import { MultiAgencyService } from 'app/shared/multi-agency/multi-agency.service';

@Component({
  selector: 'pioneer-event-match',
  templateUrl: './event-match.component.html',
  styleUrls: ['./event-match.component.css']
})
export class EventMatchComponent implements OnInit {

  public matchingSearchTextForm: FormGroup;

  pagesizeType = PagesizeType.EVENTS;

  public originalDataList: EventMatchLog[];
  public filteredDataList: EventMatchLog[];

  public matchingPage: Page<EventMatchLog>;

  defaultAgency$: Observable<MultiAgency> = this.multiAgencyService.defaultAgency$;
  agencySubscription$: Subscription = new Subscription();

  constructor(private eventMatchLogStore: EventMatchLogStore,
              private userLocalStorageService: UserLocalStorageService,
              private formBuilder: FormBuilder,
              private authenticationStore: AuthenticationStore,
              private multiAgencyService: MultiAgencyService) { }

  ngOnInit() {

    this.populateSearchTextForm('');
    this.matchingSearchTextForm = this.searchTextForm;

    this.matchingPage = Page.empty<EventMatchLog>();
    this.matchingPage.size = this.userLocalStorageService.getPagesize(PagesizeType.EVENT_MATCHING);

    this.agencySubscription$ = this.defaultAgency$.subscribe(() => {

      this.eventMatchLogStore.getEventMatchLog(0, 5, 'date', '', '').subscribe((data) => {
        this.originalDataList = data.content;
        this.filteredDataList = this.originalDataList;

        const page = this.matchingPage.number;
        const itemsPerPage = this.matchingPage.size;

        this.matchingPage.content = List<EventMatchLog>(
          this.filteredDataList.slice(page * itemsPerPage, (page + 1) * itemsPerPage)
        );
        this.matchingPage.totalElements = this.filteredDataList.length;
        this.matchingPage.numberOfElements = this.matchingPage.content.size;
      });
    });
  }

  exportEventMatchLogExcel(): void {
    this.eventMatchLogStore.exportEventMatchLogExcel().subscribe();
  }

  onRefreshMatchingList(pageNumber: number, itemsPerPage: number) {
    if ((pageNumber * itemsPerPage) >= this.filteredDataList.length) {
      pageNumber = Math.floor(this.filteredDataList.length / itemsPerPage);
    }
    this.matchingPage.content = List<EventMatchLog>(
      this.filteredDataList.slice(pageNumber * itemsPerPage, (pageNumber + 1) * itemsPerPage)
    );
    this.matchingPage.number = pageNumber;
    this.matchingPage.size = itemsPerPage;
    this.matchingPage.totalElements = this.filteredDataList.length;
    this.matchingPage.numberOfElements = this.matchingPage.content.size;
  }

  populateSearchTextForm(searchText: string): void {
    if (!this.matchingSearchTextForm) {
      this.matchingSearchTextForm = this.formBuilder.group({
        'searchText': [searchText, [ Validators.required ]]
      });
    } else {
      this.matchingSearchTextForm.patchValue({
        'searchText': searchText
      });
    }
  }

  get searchTextForm(): FormGroup {
    return this.matchingSearchTextForm;
  }

  searchByText(models: any): void {
    this.filteredDataList = [];

    this.originalDataList.forEach(item => {
      let property = '';
      if (item.propertyAddressLine1) {
        property = property + item.propertyAddressLine1 + ' ';
      }
      if (item.propertyAddressLine2) {
        property = property + item.propertyAddressLine2 + ' ';
      }
      if (item.propertyAddressLine3) {
        property = property + item.propertyAddressLine3 + ' ';
      }
      if (item.propertyState) {
        property = property + item.propertyState + ' ';
      }
      if (item.propertyZip) {
        property = property + item.propertyZip + ' ';
      }
      property = property.trim();

      if ((item.createdDate && item.createdDate.includes(models['searchText'])) ||
          (item.source      && item.source.includes(models['searchText'])) ||
          (property && property.includes(models['searchText'])) ||
          (item.startDate && item.startDate.includes(models['searchText'])) ||
          (item.endDate && item.endDate.includes(models['searchText'])) ||
          (item['createdBy'] && item['createdBy'].includes(models['searchText'])) ||
          (item.description && item.description.includes(models['searchText']))) {
        this.filteredDataList.push(item);
      }
    });

    this.matchingPage = Page.empty<EventMatchLog>();
    this.matchingPage.size = this.userLocalStorageService.getPagesize(PagesizeType.EVENT_MATCHING);

    const page = this.matchingPage.number;
    const itemsPerPage = this.matchingPage.size;

    this.matchingPage.content = List<EventMatchLog>(
      this.filteredDataList.slice(page * itemsPerPage, (page + 1) * itemsPerPage)
    );
    this.matchingPage.totalElements = this.filteredDataList.length;
    this.matchingPage.numberOfElements = this.matchingPage.content.size;

  }

  public isPropertyUser(): boolean {
    return this.authenticationStore.isPropertyUser();
  }

  public isAgencyUser(): boolean {
    return this.authenticationStore.isAgencyUser();
  }

  public isSupportUser(): boolean {
    return this.authenticationStore.isSupportUser();
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/event-match/event-match.component.ts